var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375391 11.125C0.225391 10.975 0.150391 10.8 0.150391 10.6C0.150391 10.4 0.225391 10.225 0.375391 10.075L4.45039 6.00002L0.375391 1.92502C0.225391 1.77502 0.150391 1.60002 0.150391 1.40002C0.150391 1.20002 0.225391 1.02502 0.375391 0.875024C0.525391 0.725024 0.700391 0.650024 0.900391 0.650024C1.10039 0.650024 1.27539 0.725024 1.42539 0.875024L5.92539 5.37502C6.00872 5.45836 6.07139 5.55402 6.11339 5.66202C6.15472 5.77069 6.17539 5.88336 6.17539 6.00002C6.17539 6.11669 6.15472 6.22902 6.11339 6.33702C6.07139 6.44569 6.00872 6.54169 5.92539 6.62502L1.42539 11.125C1.27539 11.275 1.10039 11.35 0.900391 11.35C0.700391 11.35 0.525391 11.275 0.375391 11.125Z",
    fill: "#4E535C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVArrow);
export default __webpack_public_path__ + "static/media/v-arrow.8bbed6ea.svg";
export { ForwardRef as ReactComponent };